import { Calendar } from 'lucide-react';

const boxCls =
  'inline-flex items-center gap-2 rounded-lg border border-gray-300 bg-white px-2.5 py-1.5 text-sm text-gray-700';
const dateCls = 'border-0 bg-transparent p-0 text-sm text-gray-700 outline-none';

/**
 * Controles de rango de fechas (Desde→Hasta) y, opcional, comparación.
 * Compacto para vivir en el header. `controls` agrupa estado + handlers para
 * no repetirlos entre el panel admin y el del cliente.
 */
export default function PanelDateControls({ controls, showCompare = false }) {
  const {
    start,
    end,
    onStartChange,
    onEndChange,
    compareMode,
    onCompareModeChange,
    customStart,
    customEnd,
    onCustomStartChange,
    onCustomEndChange,
  } = controls;

  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className={boxCls}>
        <Calendar className="h-4 w-4 shrink-0 text-gray-400" aria-hidden="true" />
        <input type="date" aria-label="Desde" value={start} onChange={onStartChange} className={dateCls} />
        <span className="text-gray-400">→</span>
        <input type="date" aria-label="Hasta" value={end} onChange={onEndChange} className={dateCls} />
      </span>

      {showCompare && (
        <select
          value={compareMode}
          onChange={onCompareModeChange}
          className="rounded-lg border border-gray-300 bg-white px-2.5 py-1.5 text-sm text-gray-600"
        >
          <option value="previous">vs. período anterior</option>
          <option value="custom">vs. personalizado</option>
        </select>
      )}

      {showCompare && compareMode === 'custom' && (
        <span className={boxCls}>
          <input type="date" aria-label="Comparar desde" value={customStart} onChange={onCustomStartChange} className={dateCls} />
          <span className="text-gray-400">→</span>
          <input type="date" aria-label="Comparar hasta" value={customEnd} onChange={onCustomEndChange} className={dateCls} />
        </span>
      )}
    </div>
  );
}
